module.exports = __webpack_public_path__ + "static/media/AddContent.6d2a954f.svg";